// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html {\n  height: 100%;\n}\nbody {\n  height: 100%;\n  background-color: #f9f9f9;\n}\n* {\n  margin: 0;\n  padding: 0;\n}\n#app {\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
